export enum PaymentTypeEnum {
  Card = 1,
  ACH = 2,
}

export const PAYMENT_TYPE_LABEL = {
  [PaymentTypeEnum.Card]: 'Card',
  [PaymentTypeEnum.ACH]: 'ACH',
};
